import { defineComponent as r, openBlock as a, createBlock as l, unref as p, mergeProps as i, withCtx as c, createElementVNode as n } from "vue";
import { RevIcon as d } from "@ds/components/Icon";
const f = /* @__PURE__ */ r({
  name: "IconWarning",
  __name: "IconWarning",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (m, e) => (a(), l(p(d), i(t, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        n("path", { d: "M11.171 13.778V9.356a.83.83 0 1 1 1.658 0v4.422a.83.83 0 1 1-1.658 0M12 17.979a.995.995 0 1 0 0-1.99.995.995 0 0 0 0 1.99" }, null, -1),
        n("path", {
          "fill-rule": "evenodd",
          d: "M10.803 3.69a1.382 1.382 0 0 1 2.394 0l8.616 14.924a1.382 1.382 0 0 1-1.197 2.073H3.384a1.382 1.382 0 0 1-1.197-2.073l8.616-14.923M12 4.936 3.863 19.029h16.274L12 4.935",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
